
export default "/assets/mastodon.5fcaf7ac.svg"